import cx from 'classnames';
import { format, parse } from 'date-fns';
import { useField } from 'formik';
import { IMaskInput } from 'react-imask';
import { FormattedDate, useIntl } from 'react-intl';

import { AllTranslationKeys } from '../../shared/intl/types';

import s from './DateFromInput.css';

type Props = {
    name: string;
    label?: AllTranslationKeys;
    errorMessage?: string;
};

export const DateFormInput = ({ errorMessage, ...props }: Props): JSX.Element => {
    const intl = useIntl();
    const [field, meta, helpers] = useField(props.name);

    const hasError = meta.touched && meta.error;

    return (
        <div className={s.dateContainer}>
            {props.label && (
                <label htmlFor={props.name}>{intl.formatMessage({ id: props.label })}</label>
            )}
            <IMaskInput
                {...field}
                {...props}
                type="text"
                mask={Date as never}
                placeholder={'DD/MM/YYYY'}
                pattern="d/`m/`Y"
                format={(date: Date) => format(date, 'dd/MM/yyyy')}
                value={field.value}
                parse={(value: string) => parse(value, 'dd/MM/yyyy', new Date())}
                min={new Date(1920, 0, 1)}
                max={new Date()}
                onAccept={(value) => {
                    void helpers.setValue(value);
                }}
                onComplete={(value) => {
                    void helpers.setValue(value);
                }}
                className={hasError ? s.inputError : s.dateInput}
                data-testid={props.name}
            />
            {hasError ? (
                <div className={cx(s.errorMessage, 'annotation')}>{errorMessage}</div>
            ) : (
                parse(field.value, 'dd/MM/yyyy', new Date()).toString() !== 'Invalid Date' && (
                    <div className={cx(s.dateText, 'annotation')}>
                        <FormattedDate
                            value={parse(field.value, 'dd/MM/yyyy', new Date())}
                            year="numeric"
                            month="long"
                            day="numeric"
                        />
                    </div>
                )
            )}
        </div>
    );
};
